import { merge, filter } from 'rxjs/operators';

class SearchSubmitButton {
  constructor(buttonElement, searchModel) {
    this.buttonElement = buttonElement;
    this.searchModel = searchModel;
    this.init();
  }

  init() {
    this.searchModel.searchResponse$
      .pipe(
        merge(
          this.searchModel.searchError$.pipe(filter(event => !event.error)),
        ),
      )
      .subscribe(() => {
        this.enable();
      });
    this.searchModel.searchDataChange$
      .pipe(
        merge(this.searchModel.searchError$.pipe(filter(event => event.error))),
      )
      .subscribe(() => {
        this.disable();
      });
  }

  enable() {
    this.buttonElement.removeAttribute('disabled');
  }

  disable() {
    this.buttonElement.setAttribute('disabled', '');
  }
}

export default SearchSubmitButton;



// WEBPACK FOOTER //
// ./src/js/search/SearchSubmitButton.js